class EnvError {
  constructor(name: string) {
    return new Error(`Required environment variable ${name} is not set`);
  }
}

function getInfonetAuthUrl(stage: string | undefined) {
    switch (stage) {
      case 'local': {
        if (!process.env.REACT_APP_INFONET_AUTH_ENDPOINT_LOCAL) {
            throw new EnvError('REACT_APP_INFONET_AUTH_ENDPOINT_LOCAL');
          }
          return process.env.REACT_APP_INFONET_AUTH_ENDPOINT_LOCAL;
      }
      case 'development': {
        if (!process.env.REACT_APP_INFONET_AUTH_ENDPOINT_DEV) {
          throw new EnvError('REACT_APP_INFONET_AUTH_ENDPOINT_DEV');
        }
        return process.env.REACT_APP_INFONET_AUTH_ENDPOINT_DEV;
      }
      case 'staging':
        if (!process.env.REACT_APP_INFONET_AUTH_ENDPOINT_STAGE) {
          throw new EnvError('REACT_APP_INFONET_AUTH_ENDPOINT_STAGE');
        }
        return process.env.REACT_APP_INFONET_AUTH_ENDPOINT_STAGE;
      case 'production':
        if (!process.env.REACT_APP_INFONET_AUTH_ENDPOINT_PROD) {
          throw new EnvError('REACT_APP_INFONET_AUTH_ENDPOINT_PROD');
        }
        return process.env.REACT_APP_INFONET_AUTH_ENDPOINT_PROD;
      default:
        throw new Error(`Unknown stage ${stage}`);
    }
  }

export const AUTH_ENDPOINT = getInfonetAuthUrl(process.env.REACT_APP_ENV);

// if (!process.env.REACT_APP_AUTH_ENDPOINT) {
//   throw new EnvError('REACT_APP_AUTH_ENDPOINT');
// }
// export const AUTH_ENDPOINT = process.env.REACT_APP_AUTH_ENDPOINT;

if (!process.env.REACT_APP_AUTH_COOKIE_NAME) {
  throw new EnvError('REACT_APP_AUTH_COOKIE_NAME');
}
export const AUTH_COOKIE_NAME = process.env.REACT_APP_AUTH_COOKIE_NAME;

if (!process.env.REACT_APP_NETMATCH_API) {
  throw new EnvError('REACT_APP_NETMATCH_API');
}
export const NETMATCH_API = process.env.REACT_APP_NETMATCH_API.replace(
  /\/$/,
  '',
);

function getInfonetBackUrl(stage: string | undefined) {
    switch (stage) {
      case 'local': {
        if (!process.env.REACT_APP_INFONET_BACKLINK_LOCAL) {
            throw new EnvError('REACT_APP_INFONET_BACKLINK_LOCAL');
          }
          return process.env.REACT_APP_INFONET_BACKLINK_LOCAL;
      }
      case 'development': {
        if (!process.env.REACT_APP_INFONET_BACKLINK_DEV) {
          throw new EnvError('REACT_APP_INFONET_BACKLINK_DEV');
        }
        return process.env.REACT_APP_INFONET_BACKLINK_DEV;
      }
      case 'staging':
        if (!process.env.REACT_APP_INFONET_BACKLINK_STAGE) {
          throw new EnvError('REACT_APP_INFONET_BACKLINK_STAGE');
        }
        return process.env.REACT_APP_INFONET_BACKLINK_STAGE;
      case 'production':
        if (!process.env.REACT_APP_INFONET_BACKLINK_PROD) {
          throw new EnvError('REACT_APP_INFONET_BACKLINK_PROD');
        }
        return process.env.REACT_APP_INFONET_BACKLINK_PROD;
      default:
        throw new Error(`Unknown stage ${stage}`);
    }
  }

export const INFONET_BACKLINK = getInfonetBackUrl(process.env.REACT_APP_ENV);

// if (!process.env.REACT_APP_INFONET_BACKLINK) {
//   throw new EnvError('REACT_APP_INFONET_BACKLINK');
// }
// export const INFONET_BACKLINK = process.env.REACT_APP_INFONET_BACKLINK;

if (!process.env.REACT_APP_CRUISESEARCH_API) {
  throw new EnvError('REACT_APP_CRUISESEARCH_API');
}
export const CRUISESEARCH_API = process.env.REACT_APP_CRUISESEARCH_API.replace(
  /\/$/,
  '',
);

function getIbeUrl(stage: string | undefined) {
  switch (stage) {
    case 'local':
    case 'development': {
      if (!process.env.REACT_APP_IBE_URL_DEV) {
        throw new EnvError('REACT_APP_IBE_URL_DEV');
      }
      return process.env.REACT_APP_IBE_URL_DEV;
    }
    case 'staging':
      if (!process.env.REACT_APP_IBE_URL_STAGE) {
        throw new EnvError('REACT_APP_IBE_URL_STAGE');
      }
      return process.env.REACT_APP_IBE_URL_STAGE;
    case 'production':
      if (!process.env.REACT_APP_IBE_URL_PROD) {
        throw new EnvError('REACT_APP_IBE_URL_PROD');
      }
      return process.env.REACT_APP_IBE_URL_PROD;
    default:
      throw new Error(`Unknown stage ${stage}`);
  }
}

export const IBE_URL = getIbeUrl(process.env.REACT_APP_ENV);

function getFeedApiUrl(stage: string | undefined) {
  switch (stage) {
    case 'local':
      /* Proxied to the test feed by devProxy (avoids CORS on localhost). */
      return '/feed/expertsearch';
    case 'development':
    case 'staging': {
      if (!process.env.REACT_APP_FEED_API_DEV) {
        throw new EnvError('REACT_APP_FEED_API_DEV');
      }
      return process.env.REACT_APP_FEED_API_DEV;
    }
    case 'production':
      if (!process.env.REACT_APP_FEED_API_PROD) {
        throw new EnvError('REACT_APP_FEED_API_PROD');
      }
      return process.env.REACT_APP_FEED_API_PROD;
    default:
      throw new Error(`Unknown stage ${stage}`);
  }
}

export const FEED_API = getFeedApiUrl(process.env.REACT_APP_ENV);

if (!process.env.REACT_APP_SENTRY_DSN) {
  throw new EnvError('REACT_APP_SENTRY_DSN');
}
export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;

if (!process.env.REACT_APP_IBE_CONTENT_API) {
  throw new EnvError('REACT_APP_IBE_CONTENT_API');
}
export const IBE_CONTENT_API = process.env.REACT_APP_IBE_CONTENT_API.replace(
  /\/$/,
  '',
);
